<div class="flex justify-center mt-25 xs:mt-25 md:mt-40 xl:mt-40 2xl:mt-40 w-full">
  <div class="flex flex-col w-[90rem] ">
    <p class="font-theme-source ml-2 mr-2 mb-1 md:mb-2 block text-2xl xs:text-4xl 2xs:text-4xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-white text-center">
      Un échange, un sourire, un feeling...<br />7 minutes suffisent
    </p>

    <p class="font-theme-source block text-base xs:text-lg 2xs:text-xl sm:text-xl md:text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-normal text-theme-black text-center mt-5 ml-2 mr-2">
      Rencontre pour de vrai des célibataires qui te ressemblent à Nantes.<br /></p>

    <div class=" xs:w-4/5 2xs:w-7/10 sm:w-5/10 md:w-[340px] lg:w-[360px] flex flex-col text-center m-auto">
      <div class="h-25 bg-theme-pink-light mt-7 shadow-xl rounded-3xl w-full p-1">
        <p class="font-theme-source text-theme-black font-bold text-base md:text-base mt-2 2xs:-mt-1 2xs:pt-2 md:mt-2 md:pt-0">
          Découvre les prochains événements de ta ville
        </p>
      </div>
      <div class="text-center w-full -mt-10 z-9992">
        <app-lp-cta class="w-full block" text="Trouve ta soirée à Nantes" faIcon="location-dot" (onClick)="goToEvents()"></app-lp-cta>
      </div>

      <div class="mt-5 2xs:mt-40">
        <div class="bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/top/anim-table.svg)] bg-top bg-contain bg-no-repeat flex-auto h-30 2xs:h-50 sm:h-70 md:h-100 mt-40 2xs:mt-10 w-full anim-center z-9991 overflow-visible">
          <div class="flex flex-row w-[120%] h-30 anim-blinking" style="display: none">
            <div class="w-1/2">
              <div class="bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/top/anim-left-item.svg)] bg-top bg-contain bg-no-repeat absolute shake-it
                      h-6 2xs:h-7 sm:h-9 lg:h-12 2xl:h-20
                      w-6 2xs:w-7 sm:w-9 lg:h-12 2xl:w-20
                      -mt-5 xs:-mt-5 2xs:-mt-7 sm:-mt-8 md:-mt-15 lg:-mt-20 xl:-mt-0
                      ml-20 xs:-ml-0 xs:ml-20 2xs:ml-10 2xs:-ml-0 sm:-ml-12 md:-ml-0 lg:-ml-5 xl:-ml-5 2xl:-ml-20 z-9991"></div>
            </div>
            <div class="w-1/2">
              <div class="bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/top/anim-right-item.svg)] bg-top bg-contain bg-no-repeat absolute shake-it
                      h-4 2xs:h-5 sm:h-5 lg:h-9 2xl:h-20
                      w-4 2xs:w-5 sm:w-5 lg:w-9 2xl:w-10
                      -mt-5 xs:-mt-5 2xs:-mt-15 md:-mt-15 lg:-mt-20 xl:-mt-0
                      ml-50 xs:ml-50 2xs:ml-42 sm:ml-55 md:ml-70 lg:ml-65 xl:ml-70 z-9991"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row">
      <div class="bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/top/anim-left-woman.svg)] bg-left-top bg-contain bg-no-repeat flex-auto anim-left
          h-55 2xs:h-70 sm:h-100 md:h-130
          w-55 2xs:w-60 sm:w-100
          -ml-10 2xs:-ml-15 sm:-ml-20
          -mt-70 2xs:-mt-90 sm:-mt-120 md:-mt-160 z-9990">
        <video class="anim-left-heart absolute z-9999 xs:w-70 sm:w-80 md:w-90 lg:w-115 xl:w-125 xs:-left-20 2xs:-left-17 sm:-left-15 md:-left-10 lg:-left-30 xs:bottom-32 2xs:bottom-42 sm:bottom-62 md:bottom-82 lg:-mt-48 xl:-mt-52"
               style="display: none" muted poster="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/animations/poster-left-heart.svg" [playbackRate]="0.8" >
          <source src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/animations/left.webm" type="video/webm" />
        </video>
      </div>

      <div class="bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/top/anim-right-man.svg)] bg-right-top bg-contain bg-no-repeat flex-auto anim-right
          h-55 2xs:h-70 sm:h-100 md:h-130
          w-55 2xs:w-60 sm:w-100
          -mr-10 2xs:-mr-15 sm:-mr-20
          -mt-70 2xs:-mt-90 sm:-mt-120
          md:-mt-160 z-9990">
        <video class="anim-right-heart absolute z-9999 xs:w-70 sm:w-80 md:w-90 lg:w-115 xl:w-125 xs:-right-20 2xs:-right-17 sm:-right-15 md:-right-10 lg:-right-30 xs:bottom-32 2xs:bottom-42 sm:bottom-62 md:bottom-82 lg:-mt-48 xl:-mt-52"
               style="display: none" muted poster="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/animations/poster-right-heart.svg" [playbackRate]="0.8" >
          <source src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/animations/right.webm" type="video/webm" />
        </video>
      </div>
    </div>


  </div>
</div>
